<template>
  <div class="plan-list">
		<table class="item-table">
			<thead>
				<tr class="item-headers">
					<th>
						<div class="bar bg-blue">
							<h3>Plan</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>Price</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>Stripe Plan ID</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>Maximum Horses</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>Mutli Yard</h3>
						</div>
					</th>
					<th class="history edit view delete" colspan="3">&nbsp;</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(plan, i) in plans" :key="i">
					<td>{{ plan.title }}</td>
					<td>&pound;{{ plan.price }}</td>
					<td>{{ plan.stripe_plan_id }}</td>
					<td>{{ plan.max_horses }}</td>
					<td>{{ plan.inc_multi_yard ? 'Yes' : 'No' }}</td>
					<td class="icon edit">
						<button class="button-transparent" @click="$emit('edit', plan)">
							<i class="ss-write ss-glyphish-filled"></i>
						</button>
					</td>
					<td class="icon delete">
						<button class="button-transparent" @click="$emit('delete', plan)">
							<i class="ss-trash ss-glyphish-filled"></i>
						</button>
					</td>
				</tr>
				<tr v-if="plans.length === 0">
					<td colspan="7">No plans found</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: ['plans']
}
</script>


// WEBPACK FOOTER //
// src/components/Plans/List.vue